function checkDaysBetween (date1, date2 ) {
  let one_day=1000*60*60*24;
  let date1_ms = date1.getTime();
  let date2_ms = new Date(date2).getTime();
  let difference_ms = date2_ms - date1_ms;
  let diff = Math.round((difference_ms/one_day)*24)
  return Math.abs(diff)
}


export { checkDaysBetween }
